import request from '@/utils/request'
// 获取验证码接口

export function getGraphKaptcha (data) {
    return request({
        url: 'notcheck/kaptcha',
        method: 'post',
        data
    })
}

export function sendEmail (query) {
    return request({
        url: 'notcheck/sendEmail',
        method: 'get',
        params: query
    })
}

export function sendSms (query) {
    return request({
        url: 'notcheck/sendSms',
        method: 'get',
        params: query
    })
}
